module.exports = __webpack_public_path__ + "static/logo-f3e449e2ac654636114dc443870cff27.svg";